module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp1_8017.e7191cab.png";